import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'
import NoInternet from '../../components/NoInternet'
import SessionTimeOutModal from '../../components/SessionTimeOutModal'
import { NotificationToastContainer } from '../../components/Toaster'
import { useOnlineStatus } from '../../hook/useOnlineStatus'
import { RootState } from '../../redux/deviceStatistics/types'
import { useSessionContex } from '../../SessionContex'

const PrivateRoute = () => {
  const { openModal } = useSessionContex()
  const isOnline = useOnlineStatus()
  const defaultUserData = useSelector((state: RootState) => state.user)

  const access_token: string | undefined | null = defaultUserData?.accessToken

  return access_token && access_token !== undefined ? (
    <>
      {!isOnline && <NoInternet />}
      {openModal && <SessionTimeOutModal />}
      {process.env.REACT_APP_ERROR === 'true' && <NotificationToastContainer />}
      <Outlet />
    </>
  ) : (
    <Navigate to='/login' />
  )
}

export default PrivateRoute
